import { createClient } from "@supabase/supabase-js";

import { SUPABASE_PUBLISHABLE_KEY, SUPABASE_URL } from "@env";

function hasText(value) {
  return typeof value === "string" && value.trim().length > 0;
}

function normalizePublicConfigValue(value) {
  return hasText(value) ? value.trim() : "";
}

export function getSupabasePublicConfig() {
  return {
    url: normalizePublicConfigValue(SUPABASE_URL),
    publishableKey: normalizePublicConfigValue(SUPABASE_PUBLISHABLE_KEY),
  };
}

export function hasSupabasePublicConfig() {
  const { url, publishableKey } = getSupabasePublicConfig();
  return hasText(url) && hasText(publishableKey);
}

export function createSupabaseBrowserClient(config = getSupabasePublicConfig()) {
  const url = normalizePublicConfigValue(config?.url);
  const publishableKey = normalizePublicConfigValue(config?.publishableKey);

  if (!url || !publishableKey) {
    throw new Error(
      "[SupabaseConfig] Missing SUPABASE_URL or SUPABASE_PUBLISHABLE_KEY.",
    );
  }

  return createClient(url, publishableKey, {
    auth: {
      autoRefreshToken: false,
      detectSessionInUrl: false,
      persistSession: false,
    },
  });
}

let supabaseBrowserClient = null;

export function getSupabaseBrowserClient() {
  if (supabaseBrowserClient) {
    return supabaseBrowserClient;
  }

  supabaseBrowserClient = createSupabaseBrowserClient();
  return supabaseBrowserClient;
}
